import React from 'react';

const ChatMessage = ({ message }) => {
  const isBot = message.sender === 'bot';
  
  return (
    <div className={`flex ${isBot ? 'justify-start' : 'justify-end'} mb-4`}>
      <div className={`rounded-lg px-4 py-3 max-w-[80%] ${
        isBot 
          ? 'bg-blue-100 text-blue-900' 
          : 'bg-green-100 text-green-900'
      }`}>
        {/* Avatar for bot messages */}
        {isBot && (
          <div className="flex items-center mb-2">
            <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center mr-2">
              <span className="text-white text-xs">AI</span>
            </div>
            <span className="font-bold text-sm">Bank Assistant</span>
          </div>
        )}
        
        <div className="text-sm whitespace-pre-wrap">
          {message.text}
        </div>
        
        {/* Sources/citations if available */}
        {isBot && message.sources && message.sources.length > 0 && (
          <div className="mt-2 text-xs text-gray-600">
            <div className="font-semibold">Sources:</div>
            <ul className="list-disc pl-4">
              {message.sources.map((source, index) => (
                <li key={index}>
                  <a 
                    href={source.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="underline hover:text-blue-700"
                  >
                    {source.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        
        {/* Timestamp */}
        <div className="text-xs text-gray-500 mt-1 text-right">
          {new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;